import { render, staticRenderFns } from "./CancelInvite.vue?vue&type=template&id=98a2b930&scoped=true&"
import script from "./CancelInvite.vue?vue&type=script&lang=js&"
export * from "./CancelInvite.vue?vue&type=script&lang=js&"
import style0 from "./CancelInvite.vue?vue&type=style&index=0&id=98a2b930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a2b930",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
